<template>
  <div class="row mt-4">
    <div class="col-12">
      <h2 class="mb-4">
        Upload Supporting Documents
      </h2>
      <p>
        You can use the fields below to upload the supporting documentation
        detailed in the Application Email from
        <span class="text-capitalize">{{ tenant.name }}</span>
        . You can also email these documents to {{ tenant.email }}.
      </p>

      <div class="row" v-for="(groupedKey, index) in groupedKeys" :key="index">
        <div class="col-12">
          <p class="mb-2" style="font-weight: bold; font-size: 16px;">
            {{ index + 1 }}. {{ groupedDocuments[groupedKey][0].name }}
          </p>
        </div>
        <!-- @foreach ($documents as $document) -->
        <div
          class="col-12 py-3 d-flex align-items-center justify-content-start"
          v-for="document in groupedDocuments[groupedKey]"
          :key="document.id"
          style="border-top: 1px solid #eeeeee"
        >
          <div v-if="document.url">
            <p class="text-muted d-inline-block mb-0">
              Status:
              <strong>Uploaded</strong>
            </p>
            <p
              class="text-muted d-inline-block ml-2 mb-0"
              style="font-style: italic;"
            >
              {{ document.name }}
            </p>
          </div>
          <file-upload
            v-else
            :modal="true"
            :key="document.id"
            style="max-width: 250px; text-align: center;"
            :endpoint="uploadEndpoint"
            :extra-fields="{ document_id: document.id }"
            :document="document"
            :upload-trigger-text="document.url ? 'Upload New' : 'Upload'"
            label="Drop dealer invoice here to upload <b><em>or</em></b> <span style='text-decoration: underline;'>click to browse</span>"
          />
        </div>
        <!-- end loop -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    application: {
      type: Object,
      required: true
    },
    applicant: {
      type: Object,
      required: true
    },
    documents: {
      type: Object,
      required: true
    },
    uploadEndpoint: {
      type: String,
      required: true
    },
    tenant: {
      type: Object,
      required: true
    }
  },
  computed: {
    groupedDocuments() {
      let arr = this.documents;
      let prop = 'document_type_id';
      const map = new Map(Array.from(arr, obj => [obj[prop], []]));
      arr.forEach(obj => map.get(obj[prop]).push(obj));
      return Array.from(map.values());
    },
    groupedKeys() {
      return Object.keys(this.groupedDocuments);
    }
  },
  mounted() {}
};
</script>
